export default __webpack_public_path__ + "static/media/landscape4.1c713dc6.jpg";